import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const GIRO_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.GiroPay,
    name: 'giropay',
    displayName: 'giropay'
};
